import styled from "@emotion/styled";
import { Button } from "@mui/material";

export const ShippingDetailsInputs = styled.div(({ theme }) => ({
	display: "flex",
	gap: "16px",
	width: "100%",
	div: {
		flex: 1
	},
	[theme.breakpoints.down("md")]: {
		flexDirection: "column"
	}
}));

export const ShippingDetailsAddressInput = styled.div(({ theme }) => ({
	display: "flex",
	gap: "16px",
	marginTop: "8px",
	width: "100%",
	justifyContent: "space-between",
	div: {
		flex: 1
	},
	[theme.breakpoints.down("md")]: {
		flexDirection: "column"
	}
}));

export const ShippingDetailsAddAddressButton = styled.div({
	justifyContent: "end",
	display: "flex"
});

export const ShippingDetailsContent = styled.div({
	display: "flex",
	flexDirection: "column",
	gap: "10px"
});

export const ReviewButton = styled(Button)({
	alignSelf: "end",
	minWidth: "160px"
});
